module.exports = __webpack_public_path__ + "static/media/rvid.8bf2002c.webm";